import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/OrdersBudget/RequestsTable';
import { Stats } from '@/components/reports/OrdersBudget/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetOrdersBudgetFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function OrdersBudget() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetOrdersBudgetFilters());
      dispatch(setSearch({ key: 'budgetReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.budget.title', 'Ongoing orders budget')}
      desc={t(
        'reports.budget.pageDesc',
        'The total allocated budget for all active orders currently in progress on the platform.'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
